import React from 'react'
import { Link } from 'react-router-dom'

const Error = () => {
	return (
		<section className="error-page section">
			<div className="error-container">
				<h1>opps! its a dead end</h1>
				<Link to="/cocktail_app" className="btn btn-primary">
					back home
				</Link>
			</div>
		</section>
	)
}

export default Error
